import { components } from './components'
import { layout } from './layout'

export const preview = { ...layout, ...components }
